export default __webpack_public_path__ + "static/media/appsyncvtl.c50062e0.png";